import { render, staticRenderFns } from "./carrier-modify.vue?vue&type=template&id=80381e50&scoped=true"
import script from "./carrier-modify.vue?vue&type=script&lang=js"
export * from "./carrier-modify.vue?vue&type=script&lang=js"
import style0 from "./carrier-modify.vue?vue&type=style&index=0&id=80381e50&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80381e50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80381e50')) {
      api.createRecord('80381e50', component.options)
    } else {
      api.reload('80381e50', component.options)
    }
    module.hot.accept("./carrier-modify.vue?vue&type=template&id=80381e50&scoped=true", function () {
      api.rerender('80381e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/carrier-modify.vue"
export default component.exports